import { Component } from '@angular/core';

@Component({
  selector: 'icon-twitter',
  templateUrl: './icon-twitter.component.html',
  styles: []
})
export class IconTwitterComponent {}
